import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, change } from 'redux-form';
import _ from 'lodash';

import { InputField, Select } from 'Common/SemanticWrapper';
import {
  NutrientsFieldEnum as Fields,
  NutritionFactFieldEnum as NutritionFactFields,
} from 'Common/FieldEnum';
import { DRVConversions, DRVFields } from 'Common/Constants/nutrients';
import { InputMode, EDIT_RECIPE_FORM_NAME } from 'Common/FormEnum';
import { WEIGHT_UNIT_OPTIONS } from 'Pages/manageingredient/helpers/Constants';

import { formatValue, getBaseWeightRatio } from './helpers/nutritionalFacts';

import 'Styles/components/nutritionalFacts.less';

class NutritionalFacts extends Component {
  static defaultProps = {
    editable: false,
    formName: '',
    hideBaseWeightField: false,
  };

  state = {
    data: {
      [Fields.Calories]: '',
      [Fields.TotalFat]: '',
      [Fields.SaturatedFat]: '',
      [Fields.TotalTrans]: '',
      [Fields.Cholesterol]: '',
      [Fields.Sodium]: '',
      [Fields.CarboHydrate]: '',
      [Fields.DietaryFiber]: '',
      [Fields.Sugars]: '',
      [Fields.AddedSugars]: '',
      [Fields.Protein]: '',
      [Fields.Water_CRV]: '',
      [Fields.Water]: '',
      [Fields.Ash_CRV]: '',
      [Fields.Ash]: '',
      [Fields.Iron_CRV]: '',
      [Fields.Iron]: '',
      [Fields.Calcium_CRV]: '',
      [Fields.Calcium]: '',
      [Fields.VitaminAIU_CRV]: '',
      [Fields.VitaminAIU]: '',
      [Fields.VitaminC_CRV]: '',
      [Fields.VitaminC]: '',
      [Fields.VitaminD_CRV]: '',
      [Fields.VitaminD]: '',
      [Fields.Potassium_CRV]: '',
      [Fields.Potassium]: '',
    },
  };

  updateNutrients = () => {
    const { formName, data, dispatch } = this.props;
    const baseWeight = Number(data[NutritionFactFields.BaseWeight]);
    if (!baseWeight) {
      return;
    }

    let ratio = getBaseWeightRatio(
      baseWeight,
      data[NutritionFactFields.BaseWeightOGL]
    );

    this.setState({
      data: {
        [Fields.Calories]: formatValue(data[Fields.Calories], ratio),
        [Fields.TotalFat]: formatValue(data[Fields.TotalFat], ratio),
        [Fields.SaturatedFat]: formatValue(data[Fields.SaturatedFat], ratio),
        [Fields.TotalTrans]: formatValue(data[Fields.TotalTrans], ratio),
        [Fields.Cholesterol]: formatValue(data[Fields.Cholesterol], ratio),
        [Fields.Sodium]: formatValue(data[Fields.Sodium], ratio),
        [Fields.CarboHydrate]: formatValue(data[Fields.CarboHydrate], ratio),
        [Fields.DietaryFiber]: formatValue(data[Fields.DietaryFiber], ratio),
        [Fields.Sugars]: formatValue(data[Fields.Sugars], ratio),
        [Fields.AddedSugars]: formatValue(data[Fields.AddedSugars], ratio),
        [Fields.Protein]: formatValue(data[Fields.Protein], ratio),
        [Fields.Water]: formatValue(data[Fields.Water], ratio),
        [Fields.Ash]: formatValue(data[Fields.Ash], ratio),
        [Fields.Iron]: formatValue(data[Fields.Iron], ratio),
        [Fields.Calcium]: formatValue(data[Fields.Calcium], ratio),
        [Fields.VitaminAIU]: formatValue(data[Fields.VitaminAIU], ratio),
        [Fields.VitaminC]: formatValue(data[Fields.VitaminC], ratio),
        [Fields.VitaminD]: formatValue(data[Fields.VitaminD], ratio),
        [Fields.Potassium]: formatValue(data[Fields.Potassium], ratio),
      },
    });

    // DRV
    DRVFields.forEach((field) => {
      let drvValue = data[`${field}_DRV`];
      if (drvValue && !isNaN(drvValue) && DRVConversions[field]) {
        let value = _.round(
          (drvValue / 100) * DRVConversions[field],
          3
        ).toFixed(3);
        dispatch(change(formName, field, value));
      }
    });
  };

  componentDidMount() {
    this.updateNutrients();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.updateNutrients();
    }
  }

  render() {
    const { data, editable, formName, hideBaseWeightField } = this.props;
    return (
      <div className="nutritional-facts-container">
        <div className="nutritional-facts-header">Nutritional Facts</div>
        <div className="nutritional-facts-body">
          {!hideBaseWeightField && editable && (
            <div className="nutritional-facts-row border">
              <div className="nutritional-facts-column left">Base Weight</div>
              <div className="nutritional-facts-column base-weight">
                <Field
                  component={InputField}
                  label={false}
                  name={NutritionFactFields.BaseWeight}
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                  hideEmptyError
                  showOnlyTouchedError
                />
              </div>
              <div className="nutritional-facts-column base-weight-ogl">
                <Field
                  component={Select}
                  label={null}
                  name={NutritionFactFields.BaseWeightOGL}
                  options={WEIGHT_UNIT_OPTIONS}
                  usePortal
                  fluid
                />
              </div>
              <div className="nutritional-facts-column right">100 Grams</div>
            </div>
          )}
          {!hideBaseWeightField && !editable && (
            <div className="nutritional-facts-row border">
              <div className="nutritional-facts-column left">Base Weight</div>
              <div className="nutritional-facts-column base-weight">
                <Field
                  component={InputField}
                  label={false}
                  name={NutritionFactFields.BaseWeight}
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                  hideEmptyError
                  showOnlyTouchedError
                  readOnly
                />
              </div>
              <div className="nutritional-facts-column base-weight-ogl">
                <Field
                  component={InputField}
                  label={false}
                  name={NutritionFactFields.BaseWeightOGL}
                  hideEmptyError
                  showOnlyTouchedError
                  readOnly
                />
              </div>
              <div className="nutritional-facts-column right">100 Grams</div>
            </div>
          )}

          {data[NutritionFactFields.QtyOfPortion] && (
            <div className="nutritional-facts-row">
              Serving Size: {data[NutritionFactFields.QtyOfPortion]}{' '}
              {data[NutritionFactFields.MeasureOfPortion]}
            </div>
          )}
          <div className="calories">
            <div className="nutritional-facts-row">
              <div className="nutritional-facts-column left bold">Calories</div>

              {editable && (
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Calories}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'kcal' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              )}
              <div className="nutritional-facts-column right full-width">
                {!editable && data[Fields.Calories]}
                {editable && this.state.data[Fields.Calories]}
                {' kcal'}
              </div>
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Total Fat</div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.TotalFat}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.TotalFat]}
              {editable && this.state.data[Fields.TotalFat]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left indent">
              Saturated Fat
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.SaturatedFat}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.SaturatedFat]}
              {editable && this.state.data[Fields.SaturatedFat]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">
              Cholesterol
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.Cholesterol}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'mg' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Cholesterol]}
              {editable && this.state.data[Fields.Cholesterol]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Sodium</div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.Sodium}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'mg' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Sodium]}
              {editable && this.state.data[Fields.Sodium]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">
              Carbohydrates
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.CarboHydrate}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.CarboHydrate]}
              {editable && this.state.data[Fields.CarboHydrate]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left indent">
              Dietary Fiber
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.DietaryFiber}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.DietaryFiber]}
              {editable && this.state.data[Fields.DietaryFiber]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left indent">
              Total Sugars
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.Sugars}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Sugars]}
              {editable && this.state.data[Fields.Sugars]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left indent">
              Added Sugars
            </div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.AddedSugars}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.AddedSugars]}
              {editable && this.state.data[Fields.AddedSugars]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row">
            <div className="nutritional-facts-column left bold">Protein</div>
            {editable && (
              <div className="nutritional-facts-column">
                <Field
                  component={InputField}
                  label={false}
                  name={Fields.Protein}
                  hideEmptyError={true}
                  fieldLabel={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  mode={InputMode.Decimal}
                  numericSize={[9, 3]}
                />
              </div>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Protein]}
              {editable && this.state.data[Fields.Protein]}
              {' g'}
            </div>
          </div>
          <div className="nutritonal-facts-hr" />
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Water</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Water}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'g' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Water]}
              {editable && this.state.data[Fields.Water]}
              {' g'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Ash</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Ash}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'g' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Ash]}
              {editable && this.state.data[Fields.Ash]}
              {' g'}
            </div>
          </div>
          <div className="nutritonal-facts-hr" />
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Iron</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Iron}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mg' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Iron]}
              {editable && this.state.data[Fields.Iron]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Calcium</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Calcium}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mg' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Calcium]}
              {editable && this.state.data[Fields.Calcium]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Vitamin A</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.VitaminAIU}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mcg RAE' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.VitaminAIU]}
              {editable && this.state.data[Fields.VitaminAIU]}
              {'  mcg RAE'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Vitamin C</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.VitaminC}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mg' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.VitaminC]}
              {editable && this.state.data[Fields.VitaminC]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Vitamin D</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.VitaminD}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mcg' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.VitaminD]}
              {editable && this.state.data[Fields.VitaminD]}
              {' mcg'}
            </div>
          </div>
          <div className="nutritional-facts-row border">
            <div className="nutritional-facts-column left bold">Potassium</div>
            {editable && (
              <React.Fragment>
                <div className="nutritional-facts-column">
                  <Field
                    component={InputField}
                    label={false}
                    name={Fields.Potassium}
                    hideEmptyError={true}
                    fieldLabel={{ basic: true, content: 'mg' }}
                    labelPosition="right"
                    mode={InputMode.Decimal}
                    numericSize={[9, 3]}
                  />
                </div>
              </React.Fragment>
            )}
            <div className="nutritional-facts-column right full-width">
              {!editable && data[Fields.Potassium]}
              {editable && this.state.data[Fields.Potassium]}
              {' mg'}
            </div>
          </div>
          <div className="nutritional-facts-row">
            {formName === EDIT_RECIPE_FORM_NAME ? (
              <div className="nutritional-facts-column full-width disclaimer">
                0* = zero Nutrient and missing Nutrient data (N/A)
                <br />
                Number* = some missing Nutrient data (N/A)
                <br />
                N/A = missing Nutrient data (N/A) for all ingredients
              </div>
            ) : (
              <div className="nutritional-facts-column full-width disclaimer">
                0 = zero Nutrient data entered
                <br />
                N/A = missing Nutrient data (blank - becomes N/A after save)
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

NutritionalFacts.propTypes = {
  data: PropTypes.shape({
    [NutritionFactFields.BaseWeight]: PropTypes.string,
    [Fields.Calories]: PropTypes.string,
    [Fields.MeasureOfPortion]: PropTypes.string,
    [Fields.TotalFat]: PropTypes.string,
    [Fields.SaturatedFat]: PropTypes.string,
    [Fields.Cholesterol]: PropTypes.string,
    [Fields.Sodium]: PropTypes.string,
    [Fields.Carbohydrate]: PropTypes.string,
    [Fields.DietaryFiber]: PropTypes.string,
    [Fields.Protein]: PropTypes.string,
    [Fields.Sugars]: PropTypes.string,
    [Fields.AddedSugars]: PropTypes.string,
    [Fields.Water_CRV]: PropTypes.string,
    [Fields.Water]: PropTypes.string,
    [Fields.Ash_CRV]: PropTypes.string,
    [Fields.Ash]: PropTypes.string,
    [Fields.Iron_CRV]: PropTypes.string,
    [Fields.Iron]: PropTypes.string,
    [Fields.Calcium_CRV]: PropTypes.string,
    [Fields.Calcium]: PropTypes.string,
    [Fields.VitaminAIU_CRV]: PropTypes.string,
    [Fields.VitaminAIU]: PropTypes.string,
    [Fields.VitaminC_CRV]: PropTypes.string,
    [Fields.VitaminC]: PropTypes.string,
    [Fields.VitaminD_CRV]: PropTypes.string,
    [Fields.VitaminD]: PropTypes.string,
    [Fields.Potassium_CRV]: PropTypes.string,
    [Fields.Potassium]: PropTypes.string,
  }).isRequired,
};

NutritionalFacts = connect()(NutritionalFacts);

export { NutritionalFacts };



// WEBPACK FOOTER //
// ./src/common/Components/NutritionalFacts/NutritionalFacts.js